import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.array.splice.js";
import { getPubDnsBlRules, createPubDnsBlRules, updatePubDnsBlRules, deletePubDnsBlRules, updateRulePriority } from "@/api/biz_pubdns_rule"; //  此处请自行替换地址
import { deepCopy } from '@/utils/viewinfo';
import infoList from "@/mixins/infoList";
export default {
  components: {},
  name: "policy",
  mixins: [infoList],
  data: function data() {
    var _this = this;
    var validateDomain = function validateDomain(rule, value, callback) {
      var reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
      if (value === '') {
        callback(new Error(_this.$t('public-dns.rule.checkvalue-error-empty')));
      } else if (!reg.test(value)) {
        callback(new Error(_this.$t('public-dns.rule.checkvalue-error-invalid')));
      } else {
        callback();
      }
    };
    return {
      listApi: getPubDnsBlRules,
      listAlias: 'pubdnsblrules',
      tmpRecords: new Map(),
      priority: 1,
      selectorOptions: [{
        value: 'domain',
        label: 'Domain'
      }, {
        value: 'host',
        label: 'Host'
      }],
      matchOptions: [{
        value: 'is',
        label: 'Is'
      }, {
        value: 'is not',
        label: 'Is not'
      }],
      actionOptions: [{
        value: 'allow',
        label: 'Allow'
      }, {
        value: 'block',
        label: 'Block'
      }],
      dialogFormVisible: false,
      isDisabledSaveBtn: false,
      formData: {
        selector: "domain",
        operator: "is",
        value: "",
        action: "allow",
        isEdit: true,
        isNew: true,
        priority: 0,
        priorityto: 0,
        movePopvisible: false
      },
      rules: {
        value: [{
          required: true,
          message: this.$t('public-dns.rule.checkvalue-error-empty'),
          trigger: 'blur'
        }, {
          trigger: 'blur',
          validator: validateDomain
        }]
      }
    };
  },
  filters: {
    formatDomain: function formatDomain(data) {
      if (data != "." && data.endsWith('.')) {
        return data.substring(0, data.length - 1);
      }
      return data;
    }
  },
  methods: {
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    deleteRow: function deleteRow(row) {
      var _this2 = this;
      this.$confirm(this.$t('common.button.delete') + ' ' + row.value + '?', this.$t('common.msg.prompt-title'), {
        confirmButtonText: this.$t('common.button.yes'),
        cancelButtonText: this.$t('common.button.no'),
        type: 'warning'
      }).then(function () {
        _this2.deleteRule(row);
      });
    },
    deleteRule: function deleteRule(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return deletePubDnsBlRules(row, _this3.$route.query.authCode);
            case 2:
              res = _context.sent;
              if (res.code == 0) {
                _this3.$message({
                  type: "success",
                  message: _this3.$t('common.msg.delete-success')
                });
                if (_this3.tableData.length == 1) {
                  _this3.page--;
                }
                _this3.getTableData();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openDialog: function openDialog() {
      this.dialogFormVisible = true;
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.isDisabledSaveBtn = false;
      this.formData = {
        selector: "domain",
        operator: "is",
        value: "",
        action: "allow",
        isEdit: true,
        isNew: true,
        priority: 0,
        priorityto: 0,
        movePopvisible: false
      };
      this.$refs['formData'].resetFields();
    },
    enterDialog: function enterDialog(formName) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var isOk, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              isOk = true;
              _this4.$refs[formName].validate(function (valid) {
                if (!valid) {
                  isOk = false;
                  return false;
                }
              });
              if (isOk) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              _this4.isDisabledSaveBtn = true;
              _context2.next = 7;
              return createPubDnsBlRules(_this4.formData, _this4.$route.query.authCode);
            case 7:
              res = _context2.sent;
              if (res.code == 0) {
                _this4.$message({
                  type: "success",
                  message: _this4.$t('common.msg.save-success')
                });
                _this4.closeDialog();
                _this4.getTableData();
              } else {
                _this4.isDisabledSaveBtn = false;
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addRow: function addRow() {
      if (this.tableData.length > 0 && this.tableData[0].isNew) {
        return;
      }
      var rid = 0;
      this.tableData.unshift({
        id: rid,
        selector: "domain",
        operator: "is",
        value: "",
        action: "allow",
        isEdit: true,
        isNew: true,
        priority: 0,
        priorityto: 0,
        movePopvisible: false
      });
      // // 设置焦点
      // this.$nextTick(() => {
      //   const recordValues = this.$refs['recordValue__' + rid]
      //   if(recordValues && recordValues.length> 0){
      //     recordValues[0].focus()
      //   }
      // })
    },
    copyToTmpRecord: function copyToTmpRecord(row) {
      if (!this.tmpRecords.has(row.ID)) {
        this.tmpRecords.set(row.ID, deepCopy(row));
      }
      console.log(this.tmpRecords);
    },
    getTmpRecord: function getTmpRecord(id) {
      return deepCopy(this.tmpRecords.get(id)) || {};
    },
    recordEdit: function recordEdit(row) {
      this.copyToTmpRecord(row);
      row.value = this.$options.filters['formatDomain'](row.value);
      this.$set(row, 'isEdit', true);
    },
    cancelEdit: function cancelEdit(row, idx) {
      if (row.isNew) {
        this.tableData.splice(idx, 1);
      } else {
        this.tableData.splice(idx, 1, this.getTmpRecord(row.ID));
      }
    },
    saveRecord: function saveRecord(row) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var errMsg, reg, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              errMsg = '';
              reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
              if (row.value === '') {
                errMsg = _this5.$t('public-dns.rule.checkvalue-error-empty');
              } else if (!reg.test(row.value)) {
                errMsg = _this5.$t('public-dns.rule.checkvalue-error-invalid');
              }
              if (!(errMsg != '')) {
                _context3.next = 6;
                break;
              }
              _this5.$message({
                type: 'error',
                showClose: true,
                message: errMsg
              });
              return _context3.abrupt("return", false);
            case 6:
              _context3.next = 8;
              return updatePubDnsBlRules(row, _this5.$route.query.authCode);
            case 8:
              res = _context3.sent;
              if (res.code == 0) {
                _this5.$message({
                  type: "success",
                  message: _this5.$t('common.msg.save-success')
                });
                row.isNew = false;
                row.isEdit = false;
                // this.getTableData()
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getOptionLabel: function getOptionLabel(options, val) {
      var _iterator = _createForOfIteratorHelper(options),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.value == val) {
            return item.label;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    moveTo: function moveTo(row) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(row.priorityto < 0 || row.priorityto > _this6.total)) {
                _context4.next = 3;
                break;
              }
              _this6.$message({
                type: 'error',
                showClose: true,
                message: _this6.$t('public-dns.rule.move-error-invalid')
              });
              return _context4.abrupt("return", false);
            case 3:
              _context4.next = 5;
              return updateRulePriority(_objectSpread(_objectSpread({}, row), {}, {
                authcode: _this6.$route.query.authCode
              }));
            case 5:
              res = _context4.sent;
              if (res.code == 0) {
                _this6.$message({
                  type: "success",
                  message: _this6.$t('common.msg.save-success')
                });
                _this6.getTableData();
                row.movePopvisible = false;
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this7.searchInfo.authcode = _this7.$route.query.authCode;
            _context5.next = 3;
            return _this7.getTableData();
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};